import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Loader from '../Loader/Loader';
import './LoaderButton.scss';
import { withTranslation } from 'react-i18next'

const LoaderButton = ({ disabled, isLoading, processingText, label, t, dataTestId,
                        className, onClick, dataToggle, dataTarget, dataDismiss, type, }) => {
  const isButtonDisabled = disabled || isLoading;
  const processingMessage = processingText || `${t('processing')}...`;
  const labelText = isLoading ? processingMessage : label;
  const buttonClasses = classNames('submit-button', className);
  return (
    <button dataTestId={dataTestId} disabled={isButtonDisabled} type={type} data-toggle={dataToggle} data-target={dataTarget} data-dismiss={dataDismiss} onClick={onClick} className={buttonClasses}>
      {isLoading && <Loader />}
      <span className="inline-block-label">{labelText}</span>
    </button>
  );
};

LoaderButton.propTypes = {
  t: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
  dataTestId: PropTypes.string,
  isLoading: PropTypes.bool,
  processingText: PropTypes.string,
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
  dataToggle: PropTypes.string,
  dataDismiss: PropTypes.string,
  dataTarget: PropTypes.string,
  onClick: PropTypes.func,
  className: PropTypes.string,
  type: PropTypes.string,
};

LoaderButton.defaultProps = {
  disabled: false,
  dataTestId: '',
  isLoading: false,
  processingText: null,
  label: '',
  className: '',
  dataTarget: '',
  onClick: null,
  type: 'submit',
  dataToggle: '',
  dataDismiss: '',
};

export default withTranslation('translation')(LoaderButton);
